/*# sourceMappingURL=vt-results-table-actions.component-5VCX2LVI.css.map */
